import React, { useState } from "react";
import HeaderPrelogin from "./header";
import ApiService from "../../services/api.service";
import ErrMapper from '../common/ErrMapper'
import Loader from '../common/Loader'
import { addUserDetails } from "../../store/actions/saveUserCredentials";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
function Newpassword({ setPage, setSuccessVisible, userName, setUserCredentials }) {
    const [step, setStep] = useState("login");
    const [loader, showLoader] = useState(false);
    const [error, setError] = useState('');
    const [newPasswprd, setNewPassword] = useState();
    const [confirmPasswprd, setConfirmPassword] = useState();
    const dispatch = useDispatch();
    const [togglePassword, setPasswordVisible] = useState(false);
    const [toggleConfirm, setConfirmVisible] = useState(false);
    const toggleView = (t) => {
        t === 2 ? setConfirmVisible(prevCheck => !prevCheck) : setPasswordVisible(prevCheck => !prevCheck)

    }
    const handleConfirm = (e) => {
        (e !== newPasswprd) ? setError("Passwords must match") : setError(''); setConfirmPassword(e)
    }
    const handleNewpassword = (e) => {
        e.preventDefault();
        // setSuccessVisible(true)
        showLoader(true)
        const payload = {
            username: userName,
            password: newPasswprd,
            confirmPassword: confirmPasswprd
            // IP: "172.16.20.49"
        }
        ApiService.post("/auth/new_password", payload).subscribe((res) => {
            showLoader(false)
            if (res.status === 200) {
                showLoader(false)
                setSuccessVisible(true)
                setUserCredentials(res.data)
                dispatch(addUserDetails(res.data))
                // setPage("password")
                //    step === "login"? (e)=>{ setStep("password")} :(e)=>{setModalVisible(true)}
            }
            else if (res.status === 400 && res.error === "Agrodealer does not exist") {
                setError(res.error);
                showLoader(false)
            }
            else if (res.response !== undefined && res.response.status === 400) {
                setError(res.error);
                showLoader(false)
            }
            else if (res.statusCode === "400") {
                showLoader(false)
                setError("Something went Wrong");
            } else {
                setError("An error occured");
            }

        })

    }

    return (
        <div className="self_service password_set">
            <HeaderPrelogin journey="Set new password" />
            <Loader loader={loader} />
            <div className="self_service_wrapper">
                <h3 className="self_service_wrapper_heading">
                    Set new passwordd
                </h3>
                <form className="verify_wrapper_form">
                    <div className="verify_wrapper_form_container">
                        <label htmlFor="farmer_id" className="verify_wrapper_form_label">
                            New password
                        </label>
                        <div className="verify_wrapper_form_container_sub">
                            <input type={togglePassword ? "text" : "password"} onChange={(e) => setNewPassword(e.target.value)} placeholder="x x x x x x x x" id="farmer_id" className="verify_wrapper_form_input" />
                            {<svg id="icon-remove_red_eye" className="eye toggle-eye" onClick={toggleView} viewBox="0 0 26 26">  {togglePassword ? <path d="M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"></path> : <path d="M11.859 9h0.141q1.219 0 2.109 0.891t0.891 2.109v0.188zM7.547 9.797q-0.563 1.125-0.563 2.203 0 2.063 1.477 3.539t3.539 1.477q1.078 0 2.203-0.563l-1.547-1.547q-0.375 0.094-0.656 0.094-1.219 0-2.109-0.891t-0.891-2.109q0-0.281 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266q-0.234-0.234-1.477-1.453t-1.898-1.875q-2.016 0.844-4.359 0.844-3.703 0-6.703-2.063t-4.313-5.438q0.516-1.219 1.617-2.695t2.133-2.273q-0.563-0.563-1.57-1.594t-1.148-1.172zM12 6.984q-0.938 0-1.828 0.375l-2.156-2.156q1.828-0.703 3.984-0.703 3.703 0 6.68 2.063t4.289 5.438q-1.125 2.766-3.422 4.734l-2.906-2.906q0.375-0.891 0.375-1.828 0-2.063-1.477-3.539t-3.539-1.477z"></path>} </svg>}
                        </div>
                    </div>
                    <div className="verify_wrapper_form_container">
                        <label htmlFor="farmer_id" className="verify_wrapper_form_label">
                            New password
                        </label>
                        <div className="verify_wrapper_form_container_sub">
                            <input onChange={(e) => handleConfirm(e.target.value)} type={toggleConfirm ? "text" : "password"} placeholder="x x x x x x x x" id="farmer_id_confirm" className="verify_wrapper_form_input" />
                            {<svg id="icon-remove_red_eye" className="eye toggle-eye" onClick={(e) => { toggleView(2) }} viewBox="0 0 26 26">  {toggleConfirm ? <path d="M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"></path> : <path d="M11.859 9h0.141q1.219 0 2.109 0.891t0.891 2.109v0.188zM7.547 9.797q-0.563 1.125-0.563 2.203 0 2.063 1.477 3.539t3.539 1.477q1.078 0 2.203-0.563l-1.547-1.547q-0.375 0.094-0.656 0.094-1.219 0-2.109-0.891t-0.891-2.109q0-0.281 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266q-0.234-0.234-1.477-1.453t-1.898-1.875q-2.016 0.844-4.359 0.844-3.703 0-6.703-2.063t-4.313-5.438q0.516-1.219 1.617-2.695t2.133-2.273q-0.563-0.563-1.57-1.594t-1.148-1.172zM12 6.984q-0.938 0-1.828 0.375l-2.156-2.156q1.828-0.703 3.984-0.703 3.703 0 6.68 2.063t4.289 5.438q-1.125 2.766-3.422 4.734l-2.906-2.906q0.375-0.891 0.375-1.828 0-2.063-1.477-3.539t-3.539-1.477z"></path>} </svg>}
                        </div>
                        <ErrMapper err={error} />
                    </div>
                </form>

            </div>
            <div className="verify_wrapper_form_container_btns">
                <button onClick={() => setPage("login")} className="verify_wrapper_form_btn_verify select back">
                    Back
                </button>
                <button onClick={handleNewpassword} className="verify_wrapper_form_btn_verify select">
                    Submit
                </button>
            </div>
        </div>
    );
}

export default Newpassword;
